// removed by extract-text-webpack-plugin
module.exports = {"global-footer":"GlobalFooter__global-footer","globalFooter":"GlobalFooter__global-footer","container":"GlobalFooter__container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/GlobalFooter.mobile.css
// module id = 1380
// module chunks = 8